<template>
  <div>
    <div class="row justify-content-center">
      <div class="col-12">
        <div class="">
          <div class="card-body p-0 pb-10 d-flex flex-column">
            <div class="row">
              <div class="col-12 font-weight-bolder font-size-h3 mb-8">
                VideoBlog
              </div>
            </div>
            <div class=" tutorial-single row">
              <div class="col-12 col-md-8">
                <div class="card" v-if="tutorial">
                  <div class="video-container">
                    <iframe
                      frameborder="0"
                      :src="
                        'https://www.youtube.com/embed/' +
                          getVideoId(tutorial.videoUrl)
                      "
                    ></iframe>
                  </div>
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-12 col-md-9">
                        <p>
                          <small>{{
                            tutorial.createdAt | moment("DD MMMM YYYY")
                          }}</small>
                        </p>
                        <h1>{{ tutorial.title }}</h1>
                        <div class="tags">
                          <span
                            class="badge badge-success mr-2"
                            v-for="t of tutorial.tags"
                            :key="t._id"
                          >
                            {{ getTagInfo(t) }}
                          </span>
                        </div>
                      </div>
                      <div class="col-12 col-md-3 text-right">
                        <span
                          class="badge p-4 px-8 likes"
                          v-bind:class="{
                            'badge-danger': checkLike(me),
                            'badge-light': !checkLike(me)
                          }"
                          @click="like(me)"
                        >
                          <i class="fa fa-thumbs-up"></i>
                          {{ tutorial.likes.length }}
                          <span class="ml-3" v-if="!checkLike(me)">Likes</span>
                          <span class="ml-3" v-else><b>Like it!</b></span>
                        </span>
                      </div>
                    </div>
                    <div class="mt-5" v-html="tutorial.description"></div>
                    <div class="mt-10" v-if="tutorial.projects.length > 0">
                      <h4>Projects related to this tutorial</h4>
                      <b-row>
                        <b-col v-for="p of tutorial.projects" :key="p._id">
                          <router-link :to="'/projects/' + p"
                            ><b-card class="p-5" no-body>
                              <b-row>
                                <b-col cols="3"
                                  ><img
                                    :src="
                                      'https://api.xupxup.net/public/uploads/projects/' +
                                        getProject(p).image
                                    "
                                /></b-col>
                                <b-col>{{ getProject(p).title }}</b-col>
                              </b-row>
                            </b-card>
                          </router-link>
                        </b-col>
                      </b-row>
                    </div>
                    <div class="published">
                      <div
                        class="users symbol-group"
                        v-if="!tutorial.teams.length > 0"
                      >
                        <span
                          class="symbol symbol-circle symbol-50px"
                          v-for="u of tutorial.users"
                          :key="u._id"
                        >
                          <img :src="getUserPhoto(u)" />
                          <span class="user-name">{{ getUserName(u) }}</span>
                        </span>
                      </div>
                      <div class="users symbol-group" v-else>
                        <span
                          class="symbol symbol-circle symbol-50px"
                          v-for="u of tutorial.teams"
                          :key="u._id"
                        >
                          <img :src="getTeamPhoto(u)" />
                          <span class="user-name">{{ getTeamName(u) }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <h2
                  class="font-weight-bolder font-size-h4 my-4"
                  v-if="tutorial && tutorial.comments"
                >
                  Replies ({{ tutorial.comments.length }})
                </h2>
                <div
                  class="replies"
                  v-if="tutorial && tutorial.comments.length > 0"
                >
                  <div
                    class="card card-reply mb-2"
                    v-for="r in tutorial.comments"
                    :key="r._id"
                  >
                    <div class="card-body p-0">
                      <div class="row align-items-center">
                        <div class="col-12 col-md-2 user-reply text-center">
                          <div class="user symbol symbol-circle">
                            <img :src="getUserPhoto(r.user)" />
                          </div>
                        </div>
                        <div class="col-12 col-md-9">
                          <p class="text-muted mb-1">
                            <span class="text-muted mr-5"
                              ><b> {{ getUserName(r.user) }}</b></span
                            ><small>{{
                              r.createdAt | moment("D MMM YYYY")
                            }}</small>
                          </p>

                          <div v-html="r.text"></div>
                        </div>
                        <div class="col-12 col-md-1 text-center">
                          <div
                            class="remove"
                            v-if="checkAdmin(roles, me)"
                            @click="remove(r._id)"
                          >
                            <button class="btn">
                              <i class="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="no-comments" v-else>
                  <p>There is no comments in this post.</p>
                </div>
                <div class="reply mt-5">
                  <p>Do you want to reply?</p>
                  <b-form v-on:submit.prevent="sendReply(me)">
                    <vue-editor
                      id="textarea5"
                      :editor-toolbar="customToolbar"
                      v-model="form.text"
                    ></vue-editor>
                    <input
                      type="submit"
                      value="Publish"
                      class="btn mt-2 btn-info"
                    />
                  </b-form>
                </div>
              </div>
              <div
                class="col-12 col-md-4 relateds"
                v-if="getRelated().length > 0"
              >
                <div class="items">
                  <h2>Related videos</h2>
                  <router-link
                    :to="'/videoblog/' + r._id"
                    v-for="r of getRelated()"
                    :key="r._id"
                  >
                    <div class="row related">
                      <div class="col-4 p-0">
                        <div
                          class="cover"
                          v-bind:style="{
                            backgroundImage:
                              'url(http://img.youtube.com/vi/' +
                              getVideoId(r.videoUrl) +
                              '/0.jpg)'
                          }"
                        ></div>
                      </div>
                      <div class="col-8">
                        <h3>{{ r.title }}</h3>
                        <div class="tags">
                          <span
                            class="badge badge-success mr-2"
                            v-for="t of r.tags"
                            :key="t._id"
                          >
                            {{ getTagInfo(t) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <div class="col-12 col-md-4 relateds" v-else>
                <div class="items">
                  <h2>Other interesting videos</h2>
                  <router-link
                    :to="'/videoblog/' + r._id"
                    v-for="r of getNotRelated().slice(0, 5)"
                    :key="r._id"
                  >
                    <div class="row related">
                      <div class="col-4 p-0">
                        <div
                          class="cover"
                          v-bind:style="{
                            backgroundImage:
                              'url(http://img.youtube.com/vi/' +
                              getVideoId(r.videoUrl) +
                              '/0.jpg)'
                          }"
                        ></div>
                      </div>
                      <div class="col-8">
                        <h3>{{ r.title }}</h3>
                        <div class="tags">
                          <span
                            class="badge badge-success mr-2"
                            v-for="t of r.tags"
                            :key="t._id"
                          >
                            {{ getTagInfo(t) }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import "@/core/plugins/collapse";
import axios from "axios";
//import LazyYoutube from "vue-lazytube";

export default {
  name: "forum-single",
  components: {},
  data() {
    return {
      series: [],
      form: {},
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "code-block"],
        [{ indent: "-1" }, { indent: "+1" }],
        ["link", "clean"]
      ]
    };
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "VideoBlog",
        subtitle: this.$store.getters.getTutorials.find(
          t => t._id === this.$route.params.tutorialId
        ).title
      }
    ]);
  },
  methods: {
    getProject(project) {
      return this.projects.find(p => project === p._id);
    },
    getVideoId(url) {
      let ID = "";
      url = url
        .replace(/(>|<)/gi, "")
        .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
      if (url[2] !== undefined) {
        ID = url[2].split(/[^0-9a-z_-]/i);
        ID = ID[0];
      } else {
        ID = url;
      }
      return ID;
    },

    checkAdmin(roles) {
      let admin = roles.filter(r => r.name === "admin" || r.name === "teacher");
      for (let i = 0; i < admin.length; i++) {
        if (admin[i].name === "teacher" || admin[i].name === "admin") {
          return true;
        }
      }
    },
    getUser(u) {
      return this.users.find(user => user._id == u);
    },
    getUserName(u) {
      let username = this.users.find(user => user._id == u);
      return username?.firstName + " " + username?.lastName;
    },
    getUserPhoto(u) {
      let user = this.users.find(user => user._id == u);
      return user?.avatar
        ? process.env.VUE_APP_API_URL + user.avatar
        : "/media/svg/avatars/001-boy.svg";
    },
    getTeamName(u) {
      let team = this.teams.find(user => user._id == u);
      return team?.name;
    },
    getTeamPhoto(u) {
      let team = this.teams.find(user => user._id == u);
      return team?.logo
        ? process.env.VUE_APP_API_URL + team.logo
        : "/media/svg/avatars/001-boy.svg";
    },
    getTagInfo(t) {
      let tag = this.tags.find(tag => tag._id == t);
      return tag?.name;
    },

    getNotRelated() {
      let relateds = this.tutorials;
      return relateds.filter(re => re._id != this.tutorial._id);
    },
    getRelated() {
      let relateds = [];
      this.tutorial.tags.forEach(t => {
        relateds = this.tutorials.filter(tutorial => tutorial.tags.includes(t));
      });

      relateds = relateds.filter(
        (value, index, self) =>
          index === self.findIndex(t => t._id === value._id)
      );
      relateds = relateds.filter(re => re._id != this.tutorial._id);
      return relateds;
    },
    isSolved(c) {
      // console.log(c.filter(i => i.isSolved));
      return c.filter(i => i.isSolved);
    },
    checkLike(user) {
      return this.tutorial.likes.includes(user._id);
    },
    like(user) {
      console.log(this.tutorial, user);
      if (!this.tutorial.likes.includes(user._id)) {
        this.tutorial.likes.push(user._id);
      } else {
        const index = this.tutorial.likes.indexOf(user._id);
        console.log(index);
        this.tutorial.likes.splice(index, 1);
      }
      axios
        .put("tutorials/" + this.tutorial._id, this.tutorial)
        .then(response => {
          console.log("response", response);
          this.$store.dispatch("fetchTutorials");
        });
    },
    remove(c) {
      let index = this.tutorial.comments.findIndex(co => co._id == c);
      this.tutorial.comments.splice(index, 1);
      axios
        .put("tutorials/" + this.tutorial._id, this.tutorial)
        .then(response => {
          console.log("response", response);
          this.$store.dispatch("fetchTutorials");
        });
    },

    sendReply(user) {
      this.form.user = user._id;
      console.log("form", user, this.form);
      axios
        .put("tutorials/" + this.tutorial._id + "/comment", {
          comments: this.form
        })
        .then(response => {
          console.log("response", response);
          this.$store.dispatch("fetchTutorials");
          this.form = {};
        });
    }
  },
  computed: {
    me() {
      return this.$store.getters.getMyUser;
    },
    admin() {
      let roles = this.$store.getters.getRoles.find(
        r => r.name === "admin" || r.name === "teacher"
      );

      let isAdmin = roles
        ? this.$store.getters.getMyUser.roles.includes(roles._id)
        : null;
      return isAdmin;
    },
    roles() {
      return this.$store.getters.getRoles;
    },
    tutorial() {
      return this.$store.getters.getTutorials.find(
        f => f._id === this.$route.params.tutorialId
      );
    },
    tutorials() {
      return this.$store.getters.getTutorials;
    },
    projects() {
      return this.$store.getters.getProjects;
    },
    users() {
      return this.$store.getters.getUsers;
    },
    teams() {
      return this.$store.getters.getTeams;
    },
    tags() {
      return this.$store.getters.getTags;
    },
    ...mapGetters(["currentUser"])
  }
};
</script>

<style lang="scss">
.tutorial-single {
  .card {
    overflow: hidden;
    .likes {
      cursor: pointer;
    }
    .users {
      margin-top: 30px;
      .symbol {
        box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
        background: white;
        aspect-ratio: 1/1;
        display: flex;
        align-items: center;
        img {
          width: 100%;
          height: auto;
        }
        .user-name {
          position: absolute;
          top: -20px;
          left: -15px;
          font-size: 8px;
          width: 80px;
          max-width: 100px;
          background: rgba(0, 0, 0, 0.7);
          border-radius: 3px;
          padding: 3px 5px;
          text-align: center;
          display: none;
          color: white;
        }
        &:hover {
          .user-name {
            display: inline-block;
          }
        }
      }
    }
  }
  .relateds {
    position: relative;
    h2 {
      color: black;
      border-left: 4px solid black;
      padding-left: 10px;
      margin-bottom: 20px;
    }

    .related {
      padding: 0;
      margin: 0;
      background-color: white;
      margin-bottom: 5px;
      align-items: center;
      border-radius: 3px;
      img {
        width: 100%;
      }
      h3 {
        color: black;
        font-size: 13px;
        margin: 0;
      }
      .cover {
        aspect-ratio: 16/9;
        background-position: center center;
        background-size: cover;
      }
      .tags {
        .badge {
          font-size: 8px;
          margin-top: 5px;
        }
      }
    }
  }
  .video-container {
    position: relative;
    overflow: hidden;
    width: 100%;
    padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
